import { createContext, MutableRefObject, RefObject, useContext, useState } from "react"


const Context = createContext<{
  container: MutableRefObject<HTMLElement>,
  target: RefObject<Element | null>
}>(null!)

export const ScrollElementProvider = ({ value, children }) => {
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useScrollElementContext = () => {
  return useContext(Context)
}